import { defineComponent as s, openBlock as t, createElementBlock as o, mergeProps as v, unref as H, renderSlot as h, createElementVNode as e, createCommentVNode as m } from "vue";
import { useScalarIcon as d } from "../hooks/useScalarIcon.js";
const i = { key: 0 }, p = { key: 1 }, u = { key: 2 }, M = { key: 3 }, g = { key: 4 }, A = { key: 5 }, f = {
  name: "ScalarIconHighDefinition"
}, y = /* @__PURE__ */ s({
  ...f,
  props: {
    label: {},
    weight: {}
  },
  setup(l) {
    const Z = l, { bind: V, weight: n } = d(Z);
    return (r, a) => (t(), o("svg", v({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, H(V)), [
      h(r.$slots, "default"),
      H(n) === "bold" ? (t(), o("g", i, a[0] || (a[0] = [
        e("path", { d: "M180,68H156a12,12,0,0,0-12,12v96a12,12,0,0,0,12,12h24a60,60,0,0,0,0-120Zm0,96H168V92h12a36,36,0,0,1,0,72Zm-76,12V140H56v36a12,12,0,0,1-24,0V80a12,12,0,0,1,24,0v36h48V80a12,12,0,0,1,24,0v96a12,12,0,0,1-24,0ZM20,44A12,12,0,0,1,32,32H224a12,12,0,0,1,0,24H32A12,12,0,0,1,20,44ZM236,212a12,12,0,0,1-12,12H32a12,12,0,0,1,0-24H224A12,12,0,0,1,236,212Z" }, null, -1)
      ]))) : H(n) === "duotone" ? (t(), o("g", p, a[1] || (a[1] = [
        e("path", {
          d: "M224,48V208H32V48Z",
          opacity: "0.2"
        }, null, -1),
        e("path", { d: "M176,72H152a8,8,0,0,0-8,8v96a8,8,0,0,0,8,8h24a56,56,0,0,0,0-112Zm0,96H160V88h16a40,40,0,0,1,0,80Zm-64,8V136H56v40a8,8,0,0,1-16,0V80a8,8,0,0,1,16,0v40h56V80a8,8,0,0,1,16,0v96a8,8,0,0,1-16,0ZM24,48a8,8,0,0,1,8-8H224a8,8,0,0,1,0,16H32A8,8,0,0,1,24,48ZM232,208a8,8,0,0,1-8,8H32a8,8,0,0,1,0-16H224A8,8,0,0,1,232,208Z" }, null, -1)
      ]))) : H(n) === "fill" ? (t(), o("g", u, a[2] || (a[2] = [
        e("path", { d: "M196,128a32,32,0,0,1-32,32H152V96h12A32,32,0,0,1,196,128Zm36-72V200a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V56A16,16,0,0,1,40,40H216A16,16,0,0,1,232,56ZM120,88a8,8,0,0,0-16,0v32H64V88a8,8,0,0,0-16,0v80a8,8,0,0,0,16,0V136h40v32a8,8,0,0,0,16,0Zm92,40a48.05,48.05,0,0,0-48-48H144a8,8,0,0,0-8,8v80a8,8,0,0,0,8,8h20A48.05,48.05,0,0,0,212,128Z" }, null, -1)
      ]))) : H(n) === "light" ? (t(), o("g", M, a[3] || (a[3] = [
        e("path", { d: "M176,74H152a6,6,0,0,0-6,6v96a6,6,0,0,0,6,6h24a54,54,0,0,0,0-108Zm0,96H158V86h18a42,42,0,0,1,0,84Zm-62,6V134H54v42a6,6,0,0,1-12,0V80a6,6,0,0,1,12,0v42h60V80a6,6,0,0,1,12,0v96a6,6,0,0,1-12,0ZM26,48a6,6,0,0,1,6-6H224a6,6,0,0,1,0,12H32A6,6,0,0,1,26,48ZM230,208a6,6,0,0,1-6,6H32a6,6,0,0,1,0-12H224A6,6,0,0,1,230,208Z" }, null, -1)
      ]))) : H(n) === "regular" ? (t(), o("g", g, a[4] || (a[4] = [
        e("path", { d: "M176,72H152a8,8,0,0,0-8,8v96a8,8,0,0,0,8,8h24a56,56,0,0,0,0-112Zm0,96H160V88h16a40,40,0,0,1,0,80Zm-64,8V136H56v40a8,8,0,0,1-16,0V80a8,8,0,0,1,16,0v40h56V80a8,8,0,0,1,16,0v96a8,8,0,0,1-16,0ZM24,48a8,8,0,0,1,8-8H224a8,8,0,0,1,0,16H32A8,8,0,0,1,24,48ZM232,208a8,8,0,0,1-8,8H32a8,8,0,0,1,0-16H224A8,8,0,0,1,232,208Z" }, null, -1)
      ]))) : H(n) === "thin" ? (t(), o("g", A, a[5] || (a[5] = [
        e("path", { d: "M176,76H152a4,4,0,0,0-4,4v96a4,4,0,0,0,4,4h24a52,52,0,0,0,0-104Zm0,96H156V84h20a44,44,0,0,1,0,88Zm-60,4V132H52v44a4,4,0,0,1-8,0V80a4,4,0,0,1,8,0v44h64V80a4,4,0,0,1,8,0v96a4,4,0,0,1-8,0ZM28,48a4,4,0,0,1,4-4H224a4,4,0,0,1,0,8H32A4,4,0,0,1,28,48ZM228,208a4,4,0,0,1-4,4H32a4,4,0,0,1,0-8H224A4,4,0,0,1,228,208Z" }, null, -1)
      ]))) : m("", !0)
    ], 16));
  }
});
export {
  y as default
};
